<template>
  <b-modal
    :id="`modal-renew-membership-${modalType}`"
    centered
    :title="getTitle()"
    size="lg"
    @ok.prevent="handleEdit"
    @hide="resetForm"
    ok-title="提交"
    cancel-title="取消"
    :ok-disabled="false"
  >
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-form class="pt-1" @submit.prevent="handleSubmit(onSubmit)">
          <b-row>
            <b-col cols="12">
              <b-form-group
                label="目前剩餘免費搜尋次數："
                label-for="current_search_limit"
                label-cols-md="3"
              >
                <b-form-input
                  id="current_search_limit"
                  :value="supplier.search_limit"
                  readonly
                  plaintext
                />
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="X Coin 餘額："
                label-for="current_coin_balance"
                label-cols-md="3"
              >
                <b-form-input
                  id="current_coin_balance"
                  :value="coinBalance"
                  readonly
                  plaintext
                />
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="目前會員到期日："
                label-for="current_expiry_date"
                label-cols-md="3"
              >
                <b-form-input
                  id="current_expiry_date"
                  :value="supplier.membership_expiry_date"
                  readonly
                  plaintext
                />
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <validation-provider
                #default="validationContext"
                name="實收金額"
                rules="required"
              >
                <b-form-group
                  label="實收金額："
                  label-for="amount"
                  label-cols-md="3"
                  class="required"
                >
                  <b-form-input
                    id="amount"
                    v-model="formData.amount"
                    :state="getValidationState(validationContext)"
                    type="number"
                    min="0"
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12">
              <validation-provider
                #default="validationContext"
                name="轉入 X Coin 金額"
                rules="integer"
              >
                <b-form-group
                  label="轉入 X Coin 金額："
                  label-for="actual_amount"
                  label-cols-md="3"
                >
                  <b-form-input
                    id="actual_amount"
                    v-model="formData.actual_amount"
                    :state="getValidationState(validationContext)"
                    type="number"
                    min="0"
                  />
                  <small class="form-text text-muted ml-md-4">
                    此金額將自動加入到 X Coin 餘額中
                  </small>
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="會員到期日："
                label-for="membership_expiry_date"
                label-cols-md="3"
              >
                <div class="d-flex align-items-center">
                  <flat-pickr
                    v-model="formData.membership_expiry_date"
                    class="form-control"
                    :config="{
                      altInput: true,
                      altFormat: 'Y-m-d',
                      allowInput: true,
                      dateFormat: 'Y-m-d'
                    }"
                    placeholder="選擇會員到期日"
                    style="background:white;"
                  />
                  <div class="d-flex align-items-center ml-1">
                    <b-button
                      variant="outline-secondary"
                      class="btn-icon rounded-circle p-0"
                      style="width: 28px; height: 28px;"
                      v-b-popover.hover.top="'清除已選擇的日期'"
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      @click="clearDate"
                    >
                      <feather-icon icon="XIcon" size="14"/>
                    </b-button>
                    <b-button
                      variant="outline-secondary"
                      class="btn-icon rounded-circle p-0 ml-1"
                      style="width: 28px; height: 28px;"
                      v-b-popover.hover.top="'重設為原本會員到期日'"
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      @click="resetToOriginal"
                    >
                      <feather-icon icon="RotateCcwIcon" size="14"/>
                    </b-button>
                  </div>
                </div>
              </b-form-group>
            </b-col>

            <b-col cols="12" v-if="false">
              <validation-provider
                #default="validationContext"
                name="增加免費搜尋次數"
                rules="integer"
              >
                <b-form-group
                  label="增加免費搜尋次數："
                  label-for="search_limit_increase"
                  label-cols-md="3"
                >
                  <b-form-input
                    id="search_limit_increase"
                    v-model="formData.search_limit_increase"
                    :state="getValidationState(validationContext)"
                    type="number"
                    min="0"
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12">
              <validation-provider
                #default="validationContext"
                name="增加免費搜尋次數"
                rules="required"
              >
                <b-form-group
                  label="增加免費搜尋次數："
                  label-for="free_limit_increase"
                  label-cols-md="3"
                >
                  <b-form-input
                    id="free_limit_increase"
                    v-model="formData.free_limit_increase"
                    :state="getValidationState(validationContext)"
                    type="number"
                    min="0"
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12">
              <b-form-group label="備註：" label-for="remark" label-cols-md="3">
                <b-form-textarea
                  id="remark"
                  v-model="formData.remark"
                  rows="3"
                  max-rows="6"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-overlay>
    </validation-observer>
  </b-modal>
</template>

  <script>
import {
  BModal,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BRow,
  BCol,
  BOverlay,
  BFormTextarea,
  VBPopover,
  BButton

} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, integer } from "@validations";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import axiosIns from "@/libs/axios";
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BRow,
    BCol,
    BOverlay,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
    flatPickr,
    VBPopover,
    BButton
  },
  props: {
    supplier: {
      type: Object,
      required: true,
    },
    modalType: {
      type: String,
      required: true,
      validator: (value) => ["supplier-list", "approve-list"].includes(value),
    },
  },
  data() {
    return {
      loading: false,
      required,
      integer,
      config: {
        dateFormat: "Y-m-d",
        minDate: "today",
      },
      formData: {
        supplier_id: null,
        amount: 0,
        actual_amount: 0,
        membership_expiry_date: null,
        search_limit_increase: 0,
        free_limit_increase: 0,
        remark: "",
      },
    };
  },
  directives: {
    'b-popover': VBPopover,
    Ripple,
  },
  computed: {
    coinBalance() {
      // 獲取 X Coin 餘額
      if (!this.supplier) return 0;

      // 調試信息
      console.log('Supplier object:', this.supplier);
      console.log('Parent ID:', this.supplier.parent_id);
      console.log('Coin balance:', this.supplier.coin_balance);
      console.log('Parent coin balance:', this.supplier.parent_coin_balance);
      console.log('Total coins:', this.supplier.total_coins);

      // 如果有 parent_id 且有 parent_coin_balance，則顯示父帳戶的餘額
      if (this.supplier.parent_id && this.supplier.parent_coin_balance !== undefined) {
        return this.supplier.parent_coin_balance;
      }

      // 如果有 total_coins 屬性，使用它
      if (this.supplier.total_coins !== undefined) {
        return this.supplier.total_coins;
      }

      // 否則顯示自己的餘額
      return this.supplier.coin_balance || 0;
    },
  },
  methods: {
    clearDate() {
        this.formData.membership_expiry_date = null
    },

    resetToOriginal() {
        this.formData.membership_expiry_date = this.supplier.membership_expiry_date
    },
    getTitle() {
      return `續費/加購額度 - ${
        this.supplier.company_name_cn || this.supplier.company_name_en
      }`;
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    hideModal() {
      this.$bvModal.hide(`modal-renew-membership-${this.modalType}`);
    },
    resetForm() {
      this.formData = {
        supplier_id: this.supplier.id,
        amount: 0,
        actual_amount: 0,
        membership_expiry_date: null,
        search_limit_increase: 0,
        free_limit_increase: 0,
        remark: "",
      };
    },
    handleEdit() {
      if (
        !this.formData.membership_expiry_date &&
        (!this.formData.search_limit_increase ||
          this.formData.search_limit_increase == 0) &&
        (!this.formData.free_limit_increase ||
          this.formData.free_limit_increase == 0)
      ) {
        this.$swal({
          text: "必須填寫會員期限或增加免費搜尋次數其中之一",
          icon: "error",
          confirmButtonText: "確定",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
        return;
      }

      this.loading = true;

      // 註釋：實收金額轉入 X Coin 的邏輯已移至後端處理
      const createCoinRecord = () => {
        // 不再需要在前端創建 Coin 記錄，直接返回成功
        return Promise.resolve(null);
      };

      // 先更新會員資訊
      axiosIns
        .post("/supplier/renew_membership", this.formData)
        .then((response) => {
          // 如果有實收金額，創建 Coin 充值記錄
          return createCoinRecord().then(() => response);
        })
        .then((response) => {
          this.loading = false;
          this.$bvModal.hide(`modal-renew-membership-${this.modalType}`);
          this.$emit("refetch-data");
          this.$swal({
            text: response.data.message,
            icon: "success",
            confirmButtonText: "確定",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
        })
        .catch((error) => {
          this.loading = false;

          // 獲取詳細的錯誤信息
          let errorMessage = '操作失敗';

          if (error.response && error.response.data) {
            if (typeof error.response.data.message === 'object') {
              // 如果錯誤信息是對象，則將其轉換為字符串
              errorMessage = Object.values(error.response.data.message).join('\n');
            } else if (error.response.data.message) {
              errorMessage = error.response.data.message;
            }
          }

          console.error('操作失敗:', errorMessage);

          this.$swal({
            text: errorMessage,
            icon: "error",
            confirmButtonText: "確定",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
        });
    },
  },
  created() {
    this.formData.supplier_id = this.supplier.id;
  },
  watch: {
    supplier: {
      handler(newVal) {
        if (newVal) {
          this.formData.supplier_id = newVal.id;
          this.formData.membership_expiry_date = newVal.membership_expiry_date;
        }
      },
      deep: true,
      immediate: true
    }
  },
};
</script>